// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__4XPOR"};